<template>
  <div :class="classes">
    <label v-text="label"></label>
    <slot></slot>

    <p class="error-message" v-if="error" v-html="error"></p>
  </div>
</template>

<script>
import { head } from "lodash";
import { mapGetters } from "vuex";

export default {
  props: {
    attribute: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    type: {
      type: String,
      required: false,
      default: () => "text",
    },
    errorKeys: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters(["hasRegistrationError", "getRegistrationErrors"]),

    error() {
      const keys = [this.attribute, ...this.errorKeys];

      const key = keys.find(key => this.hasRegistrationError(key));

      return head(this.getRegistrationErrors(key));
    },

    classes() {
      const list = ["field", `field--${this.type}`];

      if (this.required) {
        list.push("field--required");
      }

      if (this.attribute && this.has_error) {
        list.push("field--error");
      }

      return list;
    },

    has_error() {
      const keys = [this.attribute, ...this.errorKeys];

      return keys.some(key => this.hasRegistrationError(key));
    },
  },
};
</script>
